<template>
  <section class="section-login">
    <sweet-modal ref="modal" overlay-theme="dark">
      <h3>{{ $t('message.login.confirm_email_to_activate_account') }}</h3>
      <div class="form-group">
        <input type="email"
               class="form-control input-lg"
               ref="email"
               :placeholder="$t('message.login.email')"
               v-model="loginData.email">
      </div>
      <div class="form-group">
        <button class="button-large button-block -cyan"
                :disabled="isLoggingIn"
                @click="loginApp">
            {{ isLoggingIn ? $t('message.button.loading') : $t('message.button.login') }}
        </button>
      </div>
    </sweet-modal>
  </section>
</template>

<script>
  import { mapState } from 'vuex'
  import { SweetModal } from 'sweet-modal-vue'

  export default {
    props: ['loginData'],
    components: {
      SweetModal
    },
    computed: {
      ...mapState('auth', ['isLoggingIn'])
    },
    methods: {
      openModal () {
        this.$refs.modal.open()
      },
      closeModal () {
        this.$refs.modal.close()
      },
      loginApp () {
        const emailFormat = new RegExp('^([a-z0-9\\+_\\-]+)(\\.[a-z0-9\\+_\\-]+)*@([a-z0-9\\-]+\\.)+[a-z]{2,6}$')
        if (this.$refs.email.value === '') {
          this.$refs.email.focus()
        } else if (this.$refs.email.value && !emailFormat.test(this.$refs.email.value)) {
          this.$refs.email.value = ''
          this.$refs.email.focus()
        } else {
          this.$store.dispatch('auth/LOGIN', this.loginData)
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/login/RequestEmailModal.vue